import React from 'react';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { TasksRestTableWidget } from '../../../general/vol-dashboard/vol-dashboard-my-elements/management-dashboard/widgets/table-widget/tasks-table-widget/TasksRestTableWidget';
import { WidgetDisplayContextProvider } from '../../../general/vol-dashboard/vol-dashboard-my-elements/management-dashboard/WidgetDisplayContext';
// TEMPORARILY HIDDEN - imports for top row widgets
// import { Typography, CircularProgress } from '@material-ui/core';
// import { useCampfireFetch } from '../../../../global/network/useCampfireFetch';
// import { useCampfireQuery } from '../../../../global/network/useCampfireQuery';
// import { useApiUrl } from '../../../../global/config/useApiUrl';
// import { NumberWidget } from '../../../general/vol-dashboard/vol-dashboard-my-elements/management-dashboard/widgets/number-widget/NumberWidget';
// import { NumberWidget as INumberWidget } from '../../../general/vol-dashboard/vol-dashboard-my-elements/management-dashboard/dashboard-widget-setting/__generated__/NumberWidget';
// import { ComplianceScoreWidget } from './ComplianceScoreWidget';
// import { ComplianceTargetWidget } from './ComplianceTargetWidget';
// import { GET_RECOMMENDATIONS } from './get-recommendations.gql';
// import { GetRecommendations, GetRecommendationsVariables } from './__generated__/GetRecommendations';
// import { RecommendationCard } from './RecommendationCard';

const ResponsiveGridLayout = WidthProvider(Responsive);

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 0',
      minHeight: 0,
      backgroundColor: '#f1f5f5',
      overflowY: 'auto',
    },
    gridContainer: {
      padding: '0 16px',
      flex: '1 1 0',
      minHeight: 0,
    },
  })
);

// TEMPORARILY HIDDEN - Custom Recommendations Widget Component
// const RecommendationsWidget = () => {
//   const { theme } = useCampfireTheme();
//   const { data, loading } = useCampfireQuery<GetRecommendations, GetRecommendationsVariables>(GET_RECOMMENDATIONS, {
//     options: {
//       variables: { type: 'tasks-compliance' },
//     },
//   });
//
//   const recommendations = data?.vm?.recommendations || [];
//
//   const getVariant = (priority: string): 'urgent' | 'warning' | 'info' => {
//     switch (priority) {
//       case 'high':
//         return 'urgent';
//       case 'medium':
//         return 'warning';
//       case 'low':
//       default:
//         return 'info';
//     }
//   };
//
//   return (
//     <Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//       <Box style={{ padding: '16px 24px', borderBottom: `1px solid ${theme.color.grey.border}` }}>
//         <Typography style={{ fontSize: '12px', color: theme.color.grey.neutral200 }}>Recommendations</Typography>
//         <Typography style={{ fontSize: '16px', fontWeight: 600, color: theme.color.grey.neutralBrand800 }}>
//           Compliance Recommendations
//         </Typography>
//         <Typography style={{ fontSize: '12px', color: theme.color.grey.neutral200 }}>
//           Actions to improve compliance
//         </Typography>
//       </Box>
//       <Box style={{ flex: 1, padding: '16px', overflowY: 'auto' }}>
//         {loading ? (
//           <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//             <CircularProgress size={32} />
//           </Box>
//         ) : recommendations.length === 0 ? (
//           <Box style={{ textAlign: 'center', padding: '32px 16px' }}>
//             <Typography style={{ fontSize: '14px', color: theme.color.grey.neutral200, marginBottom: '8px' }}>
//               Great work!
//             </Typography>
//             <Typography style={{ fontSize: '13px', color: theme.color.grey.neutral200 }}>
//               Your compliance score is excellent. No recommendations at this time.
//             </Typography>
//           </Box>
//         ) : (
//           recommendations.map((rec) => {
//             const variant = getVariant(rec.priority);
//             return (
//               <Box key={rec.recommendationId} style={{ marginBottom: '12px' }}>
//                 <RecommendationCard
//                   variant={variant}
//                   priority={rec.priority}
//                   title={rec.title}
//                   subtitle={rec.subtitle}
//                   description={rec.description}
//                 />
//               </Box>
//             );
//           })
//         )}
//       </Box>
//     </Box>
//   );
// };

export const Compliance = () => {
  const { isMobile } = useCampfireTheme();
  const classes = useStyles({ isMobile });

  // Filters for all widgets
  const widgetFilters = JSON.stringify({ programIds: [], activityIds: [] });

  // TEMPORARILY HIDDEN - Top row widget state and data fetching
  // const apiUrl = useApiUrl();
  // const [totalTaskCount, setTotalTaskCount] = React.useState(100);
  // const totalCountFetch = useCampfireFetch<{ count: number }>({ defer: true });
  // React.useEffect(() => {
  //   totalCountFetch
  //     .run({
  //       url: `${apiUrl}/vm/dashboard/management/tasks/possible-completions/total`,
  //       params: { filters: [] },
  //     })
  //     .then((response) => {
  //       if (response?.data?.data?.count) {
  //         setTotalTaskCount(response.data.data.count);
  //       }
  //     });
  // }, []);
  // const pendingTasksWidget: INumberWidget = {
  //   __typename: 'VOLUNTEER_NumberWidgetType',
  //   widgetId: 'pending-tasks-1',
  //   targets: JSON.stringify([{ tag: 'Tasks', name: 'awaiting' }]),
  //   filters: JSON.stringify({ programIds: [], activityIds: [] }),
  //   name: 'Tasks Pending Approval',
  //   configuration: {
  //     __typename: 'VOLUNTEER_TotalNumberConfigurationType',
  //     range: 'ALL_TIME',
  //   },
  // };

  // Define grid layouts
  // TEMPORARILY HIDDEN - Original layouts with top row widgets
  // const originalLayouts = {
  //   lg: [
  //     { i: 'tracking', x: 0, y: 0, w: 1.67, h: 1 },
  //     { i: 'compliance-score', x: 1.5, y: 0, w: 1.66, h: 0.485 },
  //     { i: 'total', x: 1.67, y: 0.485, w: 1.66, h: 0.485 },
  //     { i: 'target', x: 3.33, y: 0, w: 1.67, h: 1 },
  //     { i: 'pending', x: 0, y: 1, w: 2.5, h: 1.5 },
  //     { i: 'expiring', x: 2.5, y: 1, w: 2.5, h: 1.5 },
  //     { i: 'recently-completed', x: 0, y: 2.5, w: 2.5, h: 1.5 },
  //     { i: 'incomplete', x: 2.5, y: 2.5, w: 2.5, h: 1.5 },
  //   ],
  //   md: [
  //     { i: 'tracking', x: 0, y: 0, w: 1.33, h: 1 },
  //     { i: 'compliance-score', x: 1.33, y: 0, w: 1.34, h: 0.485 },
  //     { i: 'total', x: 1.33, y: 0.485, w: 1.34, h: 0.485 },
  //     { i: 'target', x: 2.67, y: 0, w: 1.33, h: 1 },
  //     { i: 'pending', x: 0, y: 1, w: 2, h: 1.5 },
  //     { i: 'expiring', x: 2, y: 1, w: 2, h: 1.5 },
  //     { i: 'recently-completed', x: 0, y: 2.5, w: 2, h: 1.5 },
  //     { i: 'incomplete', x: 2, y: 2.5, w: 2, h: 1.5 },
  //   ],
  // };
  const layouts = {
    lg: [
      { i: 'pending', x: 0, y: 0, w: 2.5, h: 1.5 },
      { i: 'expiring', x: 2.5, y: 0, w: 2.5, h: 1.5 },
      { i: 'recently-completed', x: 0, y: 1.5, w: 2.5, h: 1.5 },
      { i: 'incomplete', x: 2.5, y: 1.5, w: 2.5, h: 1.5 },
    ],
    md: [
      { i: 'pending', x: 0, y: 0, w: 2, h: 1.5 },
      { i: 'expiring', x: 2, y: 0, w: 2, h: 1.5 },
      { i: 'recently-completed', x: 0, y: 1.5, w: 2, h: 1.5 },
      { i: 'incomplete', x: 2, y: 1.5, w: 2, h: 1.5 },
    ],
  };

  return (
    <WidgetDisplayContextProvider>
      <Box className={classes.container}>
        <Box className={classes.gridContainer}>
          <ResponsiveGridLayout
            layouts={layouts}
            breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
            cols={{ lg: 5, md: 4, sm: 4, xs: 1, xxs: 1 }}
            rowHeight={375}
            margin={[16, 16]}
            isDraggable={false}
            isResizable={false}
            compactType='horizontal'
          >
            {/* TEMPORARILY HIDDEN - Top row compliance widgets
            <Box key='tracking' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <ComplianceTargetWidget target={totalTaskCount} filters={widgetFilters} />
            </Box>

            <Box key='compliance-score' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <ComplianceScoreWidget target={totalTaskCount} filters={widgetFilters} />
            </Box>

            <Box key='total' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <NumberWidget widget={pendingTasksWidget} compact />
            </Box>

            <Box key='target' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <RecommendationsWidget />
            </Box>
            END TEMPORARILY HIDDEN */}

            <Box key='pending' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <TasksRestTableWidget target='awaiting' filters={widgetFilters} subTitle='' />
            </Box>

            <Box key='expiring' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <TasksRestTableWidget target='expiring' filters={widgetFilters} subTitle='' />
            </Box>

            <Box key='recently-completed' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <TasksRestTableWidget target='completed' filters={widgetFilters} subTitle='' />
            </Box>

            <Box key='incomplete' style={{ background: 'white', borderRadius: 6, height: '100%' }}>
              <TasksRestTableWidget target='incomplete' filters={widgetFilters} subTitle='' />
            </Box>
          </ResponsiveGridLayout>
        </Box>
      </Box>
    </WidgetDisplayContextProvider>
  );
};
